import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ThrobberButton from 'components/ThrobberButton';
import { isAppInWebView } from 'helpers/Device';
import { translate } from 'helpers/Translate';

import { useConsentService } from '@aviv-csnt/react';

const Navigation = ({
    stepState,
    clickNext,
    clickPrevious,
    submit,
    pending,
    className,
    lastStepLabel,
}) => {
    const classes = classNames({
        'bottom-navigation': true,
        [className]: !!className,
    });
    const buttonClass = classNames({
        'bottom-navigation__buttons': true,
        'flex-row-reverse': stepState.number === 1 && !isAppInWebView(),
    });

    const { showBanner } = useConsentService('gxmp7r7GKwtteD', {
        enableTCF: false,
    });

    const handleClickCookies = () => {
        showBanner();
    };

    return (
        <div className={classes}>
            <div className="centered-content flex full-height">
                <div className={buttonClass}>
                    {stepState.number === 1 && isAppInWebView() && (
                        <div>
                            <a href="/terms">{translate('CGU')}</a>
                            {' | '}
                            <button
                                className="btn-reset btn--link"
                                type="button"
                                onClick={handleClickCookies}
                            >
                                {translate('Cookies')}
                            </button>
                        </div>
                    )}
                    {stepState.number > 1 && (
                        <button
                            type="button"
                            className="btn btn--secondary btn--previous"
                            onClick={clickPrevious}
                            disabled={stepState.number === 1}
                            tabIndex="-1"
                            data-previous
                        >
                            <span className="icon icon-arrow_downward margin-right-half" />
                            {translate('Retour')}
                        </button>
                    )}
                    {stepState.isLast && (
                        <ThrobberButton
                            type="button"
                            className="btn btn--success"
                            onClick={submit}
                            disabled={!stepState.valid}
                            pending={pending}
                            data-next
                            data-submit
                        >
                            {translate(lastStepLabel)}
                        </ThrobberButton>
                    )}
                    {!stepState.isLast && (
                        <button
                            type="button"
                            className="btn btn--primary"
                            onClick={clickNext}
                            disabled={!stepState.valid}
                            data-next
                        >
                            {translate('Suivant')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

Navigation.displayName = 'Navigation';

Navigation.propTypes = {
    className: PropTypes.string,
    clickNext: PropTypes.func,
    clickPrevious: PropTypes.func,
    lastStepLabel: PropTypes.string.isRequired,
    pending: PropTypes.bool,
    stepState: PropTypes.shape({}).isRequired,
    submit: PropTypes.func,
};

/**
 * Navigation Functional Component.
 */
export default Navigation;
